import { render, staticRenderFns } from "./AddToCartAlt.vue?vue&type=template&id=0086a9b8"
import script from "./AddToCartAlt.vue?vue&type=script&lang=js"
export * from "./AddToCartAlt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports